export interface ServiceError {
  code: string;
  message: string;
  requestIdChain?: string;
  status: number;
}

export const isServiceError = (error: unknown): error is ServiceError => {
  return error instanceof Object && "code" in error && "status" in error;
};

export const visualize = async (value: Promise<Response>) => {
  try {
    const response = await value;

    if (!response.ok) {
      // Wrap to service error
      throw await response.json();
    }

    return await response.json();
  } catch (error) {
    // Throw unknown service error
    throw error;
  }
};
